import adminRequest from '../../../config/adminRequest';
import { UsdtUri } from '../../core/configs/services';
import { BoSignHelper } from '../../../core/providers/helper/boSign-helper';
import { AdminResponse } from '../models/adminResponse';

export type TrxSweepStatus = 'scanning' | 'pending' | 'running' | 'done' | 'skipped' | 'failed';

export type TrxSweepRow = {
  walletAddress: string;
  sourceType: string;
  chainTrx: number | string | null;
  status: TrxSweepStatus;
  sweptAmount: number | string | null;
  txId: string | null;
  errorMsg: string | null;
};

export type TrxSweepEnqueueResult = {
  batchId: string;
  /** 這批一次入 scanning 的候選錢包數;真正過門檻/清空由背景 cron 逐批做。 */
  candidates: number;
};

export type TrxSweepProgress = {
  scanning: number;
  pending: number;
  running: number;
  done: number;
  skipped: number;
  failed: number;
  rows: TrxSweepRow[];
};

export class TrxSweepProvider {
  /**
   * 觸發一次性 TRX 回收:掃四類錢包鏈上餘額、拿 TRX_SWEEP_MIN 過濾、排成一個 batch。
   *
   * `enqueue` 掛了 MchBOValidateGuard(跟 abandon 的 sweepChain 一樣的通用防竄改
   * 守衛,跟商戶無關)—— body 一定要帶 boSign,否則 403 sign_invalidate。算法沿用
   * AbandonWalletProvider.sweepChain:BoSignHelper.generate(整個 body,不含 boSign 本身)。
   */
  static async enqueue(data: { code: string }) {
    const res = await adminRequest.post<AdminResponse<TrxSweepEnqueueResult>>(
      UsdtUri('admin/trx-sweep/enqueue'),
      { ...data, boSign: BoSignHelper.generate(data) },
    );
    return res.data;
  }

  /** 唯讀查詢某個 batch 的進度,不掛 2FA/boSign(跟 abandon 的 preview/scan-chain 一樣)。 */
  static async getProgress(batchId: string) {
    const res = await adminRequest.get<AdminResponse<TrxSweepProgress>>(
      UsdtUri('admin/trx-sweep/progress'),
      { params: { batchId } },
    );
    return res.data;
  }
}
